export default __webpack_public_path__ + "static/prebid-9f5db01e4265a22dac719759a0dabb92.svg";